import { render, staticRenderFns } from "./info_table.vue?vue&type=template&id=55787463&scoped=true&"
import script from "./info_table.vue?vue&type=script&lang=js&"
export * from "./info_table.vue?vue&type=script&lang=js&"
import style0 from "./info_table.vue?vue&type=style&index=0&id=55787463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55787463",
  null
  
)

export default component.exports